import { useState } from "react";
import { Download, FileDown, FileText } from "lucide-react";
import { toast } from "sonner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { download } from "../lib/api";
import { Btn } from "../components/kit";
import { useSchool } from "./ctx";
import MenuEditor from "./MenuEditor";
import DailyControl from "./DailyControl";
import MonthlyStock from "./MonthlyStock";
import Templates from "./Templates";

const WORD_FORMS = ["oficio", "capa", "cardapio_diario", "controle_diario", "controle_mensal"];

export function Downloads({ form, label }) {
  const { month } = useSchool();
  const [busy, setBusy] = useState(false);
  const go = async (fmt) => {
    setBusy(true);
    try {
      await download(`/s/export/${form}?month=${month}&fmt=${fmt}`, `${form}_${month}.${fmt}`);
    } catch (e) {
      toast.error(e.message, { duration: 9000 });
    }
    setBusy(false);
  };
  return (
    <div className="flex flex-wrap gap-2">
      <Btn variant="outline" disabled={busy} data-testid={`download-${form}-csv`} onClick={() => go("csv")}><Download className="w-4 h-4" />Planilha (CSV)</Btn>
      <Btn variant="navy" disabled={busy} data-testid={`download-${form}-pdf`} onClick={() => go("pdf")}><FileDown className="w-4 h-4" />Baixar {label} (PDF)</Btn>
      {WORD_FORMS.includes(form) && <Btn variant="outline" disabled={busy} data-testid={`download-${form}-docx`} onClick={() => go("docx")}><FileText className="w-4 h-4" />Baixar Word</Btn>}
    </div>
  );
}

export default function Forms() {
  return (
    <Tabs defaultValue="modelos">
      <TabsList className="bg-white border h-auto p-1 flex-wrap justify-start mb-5">
        {[["modelos", "Modelos em PDF"], ["cardapio", "Cardápio diário"], ["diario", "Controle diário de gêneros"], ["mensal", "Controle mensal de estoque"]].map(([v, l]) => (
          <TabsTrigger key={v} value={v} data-testid={`form-tab-${v}`} className="px-4 py-2 data-[state=active]:bg-[#1E3E62] data-[state=active]:text-white">{l}</TabsTrigger>
        ))}
      </TabsList>
      <TabsContent value="modelos"><Templates /></TabsContent>
      <TabsContent value="cardapio"><MenuEditor /></TabsContent>
      <TabsContent value="diario"><DailyControl /></TabsContent>
      <TabsContent value="mensal"><MonthlyStock /></TabsContent>
    </Tabs>
  );
}
